import { ResponsiveCard } from '../../molecules/card/Card';
import { PageSectionForCards } from '../../molecules/pageSection/PageSection';

export function OsasInvoicingInformationCard() {
    return (
        <PageSectionForCards
            chapterTitle="Kosten en betalen"
            md={12}
        >
            <ResponsiveCard
                body="Lees meer over wat en hoe jij moet betalen"
                cardTitle="Rekening / factuur"
                lg={12}
                linksText={['Meer informatie']}
                linksTo={['/osas/invoicingInformation']}
            />
        </PageSectionForCards>
    );
}
